import { SagaIterator } from 'redux-saga';
import { take, call, putResolve } from 'redux-saga/effects';
import AuthApiService from '../../../services/AuthApiService';

import { actions } from '.';

const apiService = new AuthApiService();

const sagas = {
  *fetchAuth(): SagaIterator {
    while (true) {
      yield take(actions.fetchAuthRequest);
      try {
        const {
          authenticated,
          isWorking,
          imageUrl,
          message,
          userPageAnnouncement,
        } = yield call(() => apiService.fetchAuth());
        yield putResolve(
          actions.fetchAuthSuccess(
            authenticated,
            isWorking,
            imageUrl,
            message,
            userPageAnnouncement || null,
          ),
        );
      } catch (e) {
        yield putResolve(actions.fetchAuthFailure());
      }
    }
  },
};

export default sagas;
